import React from 'react';
import { Interaction } from 'records/interactions';
import { ViewSubmittal } from 'records/interactions/ViewSubmittal';
import { Submittal, SubmittalId } from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  submittalId: SubmittalId;
}

class SubmittalDeepLink extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    const { appState, actions, submittalId } = props;

    const nextSubmittal = appState.submittals.get(submittalId, new Submittal());

    const viewSubInteractions = appState.interactions.filter(
      (i: Interaction): i is ViewSubmittal => i.type === 'ViewSubmittal'
    );

    if (viewSubInteractions.size > 0) {
      // only allowed one ViewSubmittal Interaction at a time
      const interaction = viewSubInteractions.get(0, new ViewSubmittal());

      const nextInteraction = interaction.set('submittal', nextSubmittal);

      actions.updateInteraction(nextInteraction);
    } else {
      const interaction = new ViewSubmittal({
        submittal: nextSubmittal,
      });

      actions.createInteraction(interaction);
    }
  }

  render(): React.ReactNode {
    return null;
  }
}

export default withAppStore<Props>(SubmittalDeepLink);
